import { TuiHoveredModule } from '@taiga-ui/cdk';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TuiHintModule, TuiLabelModule } from '@taiga-ui/core';

import { AitPaletteComponent } from './palette.component';
import { TuiRadioBlockModule, TuiToggleModule } from '@taiga-ui/kit';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    TuiHintModule,
    TuiRadioBlockModule,
    ReactiveFormsModule,
    FormsModule,
    TuiToggleModule,
    TuiLabelModule,
    TuiHoveredModule
  ],
  declarations: [AitPaletteComponent],
  exports: [AitPaletteComponent]
})
export class AitPaletteModule {}
